import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import React, { Component } from 'react';
import "slick-carousel/slick/slick-theme.css";

class Testimonials extends Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }

    render() {

        const settings = {
            dots: true,
            infinite: true,
            arrows: false,
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1
        };

        return (
            <Slider {...settings}>
                <div className="testimonialsBody">
                    <img src="/static/images/people1.jpg" alt="people1" />
                    <div className="testimonialsText">
                        <span>
                            "I honestly do not know where I would be if I hadn't discovered Survey Source when I did. It has formed the backbone of support for me."
                        </span>
                        <hr />
                        <div className="reviewSec">
                            <span className="reviewPersonName">Elisabeth Maarch</span>
                            <span>Land Surveyor</span>
                        </div>
                    </div>
                </div>
                <div className="testimonialsBody">
                    <img src="/static/images/people2.jpg" alt="people2" />
                    <div className="testimonialsText">
                        <span>
                            "I wanted to get a survey within a week and after connecting with Survey Source, I got the job done in the same day. I could not recommend more highly!."
                        </span>
                        <hr />
                        <div className="reviewSec">
                            <span className="reviewPersonName">Frederico Gonzzales</span>
                            <span>Technical officer, ABC Consultancy</span>
                        </div>
                    </div>
                </div>
            </Slider>
        )
    }
}

export default Testimonials;


// WEBPACK FOOTER //
// ./src/pages/Home/Testimonials.js